import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { AuthLoginService } from '../pages/login/services/auth-login.service';

export const authChangePassGuard: CanActivateFn = async (route, state) => {
  const cookie = inject(CookieService);
  const router = inject(Router);
  const auth = inject(AuthLoginService);

  const token = cookie.getAll()['x-token']
    ? cookie.getAll()['x-token']
    : route.queryParamMap.get('token');

  try {
    const token = cookie.getAll()['x-token'];

    const { ok, firstLogin, isOtp } = await firstValueFrom(auth.checkToken());
    if (ok && (!firstLogin || isOtp)) {
      return true;
    } else {
      router.navigate(['home']);
      return false;
    }
  } catch (error) {
    router.navigate(['login']);
    return false;
  }
};
